import { Prisma } from '@commenda/prisma';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TAccountantMarketplaceService } from './types';
import { UseCAFirmMembersOptions } from './useCAFirmUsers';

type CAFirm = Prisma.CAFirmGetPayload<{
  include: {
    users: {
      include: {
        user: true;
      };
    };
  };
}> & { accountingFirmMarketplaceService?: TAccountantMarketplaceService[] };

export function useCAFirms(
  token?: string | undefined,
  options?: UseCAFirmMembersOptions
) {
  const requestBaseURI = 'caFirm';

  const query = new URLSearchParams();
  if (options?.includeMarketplaceServices) {
    query.append('includeMarketplaceServices', 'true');
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: CAFirm[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `${requestBaseURI}?${query.toString()}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
